import { useLazyQuery, useQuery } from "@apollo/client";
import { CMS_LIST } from "../cms.queries";
import { CmsListQuery } from "../../../__generated__/CmsListQuery";

export const useCmsList = () => {
  return useQuery<CmsListQuery>(CMS_LIST);
};

export const useLazyCmsList = () => {
  return useLazyQuery<CmsListQuery>(CMS_LIST);
};
